import { z } from 'zod'

/**
 * The languages a cabinet may be set to: the union of what our games ship,
 * lowercase like the originals' codes. A game that does not ship the
 * cabinet's language plays en.
 */
export const CABINET_LANGUAGES = ['en', 'ru', 'tr'] as const

export const cabinetLanguageSchema = z.enum(CABINET_LANGUAGES)

export type CabinetLanguage = z.infer<typeof cabinetLanguageSchema>

/**
 * The languages the admin panel can be set to. One list: a new language is a
 * new code here, a glossary column and a catalog folder in admin-web
 * (`src/locales/<code>`).
 */
export const ADMIN_LANGUAGES = ['en', 'ru', 'tr'] as const

export const adminLanguageSchema = z.enum(ADMIN_LANGUAGES)

export type AdminLanguage = z.infer<typeof adminLanguageSchema>

/** Each language by its own name, the label of its option in a select. */
export const ADMIN_LANGUAGE_NAMES: Record<AdminLanguage, string> = {
  en: 'English',
  ru: 'Русский',
  tr: 'Türkçe',
}
